import {Injectable} from "@angular/core";
import {CreateShareProductsLinkService} from "@app/core/product/domain/services/create-share-products-link.service";
import {Observable} from "rxjs";
/**
 * Use case to generate a shareable link to share with others the selected products.
 */
@Injectable({
    providedIn: 'root'
})
export class CreateShareProductsLinkUseCase {
    constructor(
        private createShareProductsLinkService: CreateShareProductsLinkService
    ) { }

    execute(productCodes: string[]): Observable<string> {
        return this.createShareProductsLinkService.execute(productCodes);
    }
}